import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import InstallBanner from "./components/InstallBanner";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Servicios from "./pages/Servicios";
import AppPage from "./pages/AppPage";
import Nosotros from "./pages/Nosotros";
import FAQ from "./pages/FAQ";
import Contacto from "./pages/Contacto";

// Portal Técnico pages
import TecnicoLogin from "./pages/tecnico/TecnicoLogin";
import TecnicoDashboard from "./pages/tecnico/TecnicoDashboard";
import MantencionPreventiva from "./pages/tecnico/MantencionPreventiva";
import MantencionCorrectiva from "./pages/tecnico/MantencionCorrectiva";
import TecnicoHistorial from "./pages/tecnico/TecnicoHistorial";
import AdminUsuarios from "./pages/tecnico/AdminUsuarios";
import AdminClientes from "./pages/tecnico/AdminClientes";
import AdminRepuestos from "./pages/tecnico/AdminRepuestos";
import AdminServicios from "./pages/tecnico/AdminServicios";
import Cotizaciones from "./pages/tecnico/Cotizaciones";
import CotizacionEditor from "./pages/tecnico/CotizacionEditor";
import Informes from "./pages/tecnico/Informes";
import InformeEditor from "./pages/tecnico/InformeEditor";
import Bajas from "./pages/tecnico/Bajas";
import BajaEditor from "./pages/tecnico/BajaEditor";
import DashboardReportes from "./pages/tecnico/DashboardReportes";
import DetalleServicios from "./pages/tecnico/DetalleServicios";
import MisEquipos from "./pages/tecnico/MisEquipos";
import RendicionGastos from "./pages/tecnico/RendicionGastos";
import RendicionEditor from "./pages/tecnico/RendicionEditor";
import GastosConfig from "./pages/tecnico/GastosConfig";
import Productos from "./pages/Productos";
import { ClienteAuthProvider } from "./contexts/ClienteAuthContext";
import ClienteProtected from "./components/ClienteProtected";
import ClienteAcceso from "./pages/cliente/ClienteAcceso";
import ClienteDashboard from "./pages/cliente/ClienteDashboard";
import ClienteEquipo from "./pages/cliente/ClienteEquipo";
import ClienteDocumentos from "./pages/cliente/ClienteDocumentos";
import Movil from "./pages/Movil";
import ProductoDetalle from "./pages/ProductoDetalle";
import TiendaCheckout from "./pages/TiendaCheckout";
import TiendaGracias from "./pages/TiendaGracias";
import TiendaAdmin from "./pages/tecnico/TiendaAdmin";
import TiendaPedidos from "./pages/tecnico/TiendaPedidos";
import TiendaInventario from "./pages/tecnico/TiendaInventario";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ClienteAuthProvider>
        <Routes>
          {/* === Web pública (con Layout: Header + Footer + WhatsApp) === */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/servicios" element={<Layout><Servicios /></Layout>} />
          <Route path="/app" element={<Layout><AppPage /></Layout>} />
          <Route path="/nosotros" element={<Layout><Nosotros /></Layout>} />
          <Route path="/faq" element={<Layout><FAQ /></Layout>} />
          <Route path="/contacto" element={<Layout><Contacto /></Layout>} />
          <Route path="/productos" element={<Layout><Productos /></Layout>} />
          <Route path="/productos/checkout" element={<Layout><TiendaCheckout /></Layout>} />
          <Route path="/productos/gracias" element={<Layout><TiendaGracias /></Layout>} />
          <Route path="/productos/:slug" element={<Layout><ProductoDetalle /></Layout>} />

          {/* === Entrada de la APP (iOS/Android/PWA) === */}
          <Route path="/movil" element={<Movil />} />
          <Route path="/movil/:rol" element={<Movil />} />

          {/* === Portal de Clientes === */}
          <Route path="/cliente" element={<ClienteAcceso />} />
          <Route path="/cliente/dashboard" element={<ClienteProtected><ClienteDashboard /></ClienteProtected>} />
          <Route path="/cliente/equipos/:id" element={<ClienteProtected><ClienteEquipo /></ClienteProtected>} />
          <Route path="/cliente/documentos" element={<ClienteProtected><ClienteDocumentos /></ClienteProtected>} />

          {/* === Portal Técnico (SIN Layout, tiene su propio header) === */}
          <Route path="/tecnico/login" element={<TecnicoLogin />} />
          <Route path="/tecnico/dashboard" element={<ProtectedRoute><TecnicoDashboard /></ProtectedRoute>} />
          <Route path="/tecnico/mantencion/nueva" element={<ProtectedRoute><MantencionPreventiva /></ProtectedRoute>} />
          <Route path="/tecnico/mantencion/:id" element={<ProtectedRoute><MantencionPreventiva /></ProtectedRoute>} />
          <Route path="/tecnico/correctiva/nueva" element={<ProtectedRoute><MantencionCorrectiva /></ProtectedRoute>} />
          <Route path="/tecnico/correctiva/:id" element={<ProtectedRoute><MantencionCorrectiva /></ProtectedRoute>} />
          <Route path="/tecnico/historial" element={<ProtectedRoute><TecnicoHistorial /></ProtectedRoute>} />
          <Route path="/tecnico/cotizaciones" element={<ProtectedRoute adminOnly><Cotizaciones /></ProtectedRoute>} />
          <Route path="/tecnico/cotizaciones/nueva" element={<ProtectedRoute adminOnly><CotizacionEditor /></ProtectedRoute>} />
          <Route path="/tecnico/cotizaciones/:id" element={<ProtectedRoute adminOnly><CotizacionEditor /></ProtectedRoute>} />
          <Route path="/tecnico/informes" element={<ProtectedRoute><Informes /></ProtectedRoute>} />
          <Route path="/tecnico/informes/nuevo" element={<ProtectedRoute><InformeEditor /></ProtectedRoute>} />
          <Route path="/tecnico/informes/:id" element={<ProtectedRoute><InformeEditor /></ProtectedRoute>} />
          <Route path="/tecnico/bajas" element={<ProtectedRoute><Bajas /></ProtectedRoute>} />
          <Route path="/tecnico/bajas/nuevo" element={<ProtectedRoute><BajaEditor /></ProtectedRoute>} />
          <Route path="/tecnico/bajas/:id" element={<ProtectedRoute><BajaEditor /></ProtectedRoute>} />
          <Route path="/tecnico/dashboard-reportes" element={<ProtectedRoute adminOnly><DashboardReportes /></ProtectedRoute>} />
          <Route path="/tecnico/detalle-servicios" element={<ProtectedRoute adminOnly><DetalleServicios /></ProtectedRoute>} />
          <Route path="/tecnico/admin/usuarios" element={<ProtectedRoute adminOnly><AdminUsuarios /></ProtectedRoute>} />
          <Route path="/tecnico/admin/clientes" element={<ProtectedRoute adminOnly><AdminClientes /></ProtectedRoute>} />
          <Route path="/tecnico/admin/repuestos" element={<ProtectedRoute adminOnly><AdminRepuestos /></ProtectedRoute>} />
          <Route path="/tecnico/admin/servicios" element={<ProtectedRoute adminOnly><AdminServicios /></ProtectedRoute>} />
          <Route path="/tecnico/admin/equipos" element={<ProtectedRoute adminOnly><MisEquipos /></ProtectedRoute>} />
          <Route path="/tecnico/tienda" element={<ProtectedRoute adminOnly><TiendaAdmin /></ProtectedRoute>} />
          <Route path="/tecnico/tienda/pedidos" element={<ProtectedRoute adminOnly><TiendaPedidos /></ProtectedRoute>} />
          <Route path="/tecnico/inventario" element={<ProtectedRoute><TiendaInventario /></ProtectedRoute>} />
          <Route path="/tecnico/gastos" element={<ProtectedRoute><RendicionGastos /></ProtectedRoute>} />
          <Route path="/tecnico/gastos/nueva" element={<ProtectedRoute><RendicionEditor /></ProtectedRoute>} />
          <Route path="/tecnico/gastos/config" element={<ProtectedRoute adminOnly><GastosConfig /></ProtectedRoute>} />
          <Route path="/tecnico/gastos/:id" element={<ProtectedRoute><RendicionEditor /></ProtectedRoute>} />
        </Routes>
        </ClienteAuthProvider>
        <InstallBanner />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
